import { useIntl } from 'react-intl';
import { useCallback } from 'react';
import { VisitorModeButton } from '../../visit-step/components/visitor-mode-button';

interface VisitDayModeToggleProps {
  isMultiDay: boolean;
  disabled?: boolean;
  onChange: (isMultiDay: boolean) => void;
}

export const VisitDayModeToggle = ({ isMultiDay, disabled, onChange }: VisitDayModeToggleProps): JSX.Element => {
  const { formatMessage } = useIntl();

  const handleSingleDayClick = useCallback(() => {
    if (!disabled) {
      onChange(false);
    }
  }, [disabled, onChange]);

  const handleMultiDayClick = useCallback(() => {
    if (!disabled) {
      onChange(true);
    }
  }, [disabled, onChange]);

  return (
    <div data-cy="visit-day-mode-toggle">
      <p className="text-sm font-medium text-foreground mb-3">
        {formatMessage({
          id: 'createVisitFormV2.whenStep.visitTypeQuestion',
          defaultMessage: 'Is this a single-day or multi-day visit?',
        })}
      </p>
      <div className="grid grid-cols-2 gap-3">
        <VisitorModeButton
          isActive={!isMultiDay}
          disabled={disabled}
          onClick={handleSingleDayClick}
          label={formatMessage({ id: 'createVisitFormV2.whenStep.singleDay', defaultMessage: 'Single day' })}
        />
        <VisitorModeButton
          isActive={isMultiDay}
          disabled={disabled}
          onClick={handleMultiDayClick}
          label={formatMessage({ id: 'createVisitFormV2.whenStep.multiDay', defaultMessage: 'Multi-day' })}
        />
      </div>
    </div>
  );
};
